import { autoFormatMedicineDosageInformation } from "../../../../../../../services/functions";

import { SelfContent } from "./styles";

export function Self(medicine) {
  return (
    <SelfContent>{autoFormatMedicineDosageInformation(medicine)}</SelfContent>
  );
}
